/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Phase_StartingInputs */

const en_welcome_phase_starting = /** @type {(inputs: Welcome_Phase_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waking up the server`)
};

const fr_welcome_phase_starting = /** @type {(inputs: Welcome_Phase_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réveil du serveur`)
};

const ms_sg2_welcome_phase_starting = /** @type {(inputs: Welcome_Phase_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membangunkan pelayan`)
};

/**
* | output |
* | --- |
* | "Waking up the server" |
*
* @param {Welcome_Phase_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_phase_starting = /** @type {((inputs?: Welcome_Phase_StartingInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Phase_StartingInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_phase_starting(inputs)
	if (locale === "fr") return fr_welcome_phase_starting(inputs)
	return ms_sg2_welcome_phase_starting(inputs)
});